
import ContactUsSection from './contact-us-section'

export default function Privacy({ onOpenContact }: { onOpenContact?: () => void }) {
	return (
		<div className="space-y-6">
			<h1 className="scroll-m-20 text-4xl font-bold tracking-tight">Privacy Policy</h1>

			<p>Last updated: September 26, 2026</p>

			<p>
				This Privacy Policy describes how hangaround.live ("we", "us", or "our") collects, uses, 
				and discloses your personal information when you use our Service.
			</p>

			<h2>1. Age Restriction</h2>
			<p>
				Our Service is intended for use by individuals who are at least 18 years old. 
				We do not knowingly collect personal information from anyone under 18 years of age. 
				If we become aware that we have collected personal information from an individual under 18 years of age, 
				we will take steps to delete such information from our servers.
			</p>
    
			<h2>2. Information We Collect</h2>
			<p>We intentionally collect and process the following information:</p>
			<ul className="list-disc pl-4 mb-6">
				<li>Your email address (stored in encrypted form)</li>
				<li>Recent messages between you and our bot</li>
				<li>A summary of earlier messages between you and our bot</li>
					<li>Your location (general area, not an exact address)</li>
				<li>Your messages in discussion groups</li>
				<li>Campaign tag: if you reached our site through a link carrying a campaign tag (for example from a poster or a post we shared), we store that tag with your account to measure which of our outreach works. It is deleted together with your account.</li>
			</ul>

			<p>We do not actively seek or request the following types of personally identifiable information:</p>
			<ul className="list-disc pl-4 mb-6">
				<li>Full name</li>
				<li>Physical address</li>
				<li>Exact geolocation data</li>
				<li>Phone number</li>
				<li>Social security number or other government-issued identification numbers</li>
				<li>Financial information such as credit card numbers or bank account details</li>
			</ul>

			<p>Note on User-Provided Information</p>
			<p>
				While we do not explicitly collect the above-mentioned sensitive information, 
				if users choose to share any sensitive personal information in their messages to the bot or to other users,  
				this information may be stored as part of the chat history. 
				We strongly discourage users from sharing such sensitive information through our Service.
			</p>

			<p>Our Data Storage Practices</p>
			<ul className="list-disc pl-4 mb-6">
				<li>We store chat messages to provide context for future interactions and improve our Service.</li>
				<li>Users are responsible for the content they share in their messages.</li>
				<li>If you believe you have inadvertently shared sensitive information, please contact us immediately for assistance in removing it.</li>
			</ul>

			<p>
				By using our Service, you acknowledge and agree that you are responsible for the content of your messages, 
				and you should not include sensitive personal information in your interactions.
			</p>

			<h2>3. How We Use Your Information</h2>
			<p>We use the collected information for the following purposes:</p>
			<ul className="list-disc pl-4 mb-6">
				<li>To provide and maintain our Service</li>
				<li>To match you with discussion groups based on your interests</li>
				<li>To improve and personalize your experience with our Service</li>
				<li>To verify that users meet the age requirement for our Service</li>
			</ul>

			<h2>4. Data Storage and Security</h2>
			<p>
				We implement appropriate technical and organizational measures to protect the security of your personal information. 
				However, please note that no method of transmission over the Internet or method of electronic storage is 100% secure.
			</p>
			
			<h2>5. Sharing of Information</h2>
			<p>
				We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties. 
				This does not include trusted third parties who assist us in operating our service, 
				so long as those parties agree to keep this information confidential.
			</p>
			
			<h2>6. Your Data Protection Rights</h2>
			<p>
				You have the right to access, update, or delete your personal information. 
				If you wish to exercise these rights, please contact us using the information provided at the end of this policy.
			</p>
			
			<h2>7. Changes to This Privacy Policy</h2>
			<p>We may update our Privacy Policy from time to time. We will notify you of any changes by:</p>
			<ul className="list-disc pl-4 mb-6">
				<li>Posting the new Privacy Policy on this page</li>
				<li>Updating the "Last updated" date at the top of this Privacy Policy</li>
			</ul>
			<p>
				We encourage you to review this Privacy Policy periodically for any changes. 
				Changes to this Privacy Policy are effective when they are posted on this page.
			</p>

			<h2>8. Retention of Information</h2>
			<p>
				We retain your message history for as long as necessary to provide our Service. 
				You can request deletion of your data at any time by contacting us.
			</p>

			<h2>9. Sensitive Information</h2>
			<p>
				We explicitly ask users not to share sensitive information in chat messages sent to our bot. 
				However, if such information is shared, it may be stored as part of the chat history. 
				We strongly encourage users to avoid sharing any sensitive personal information through our Service.
			</p>

			<h2>10. Contact Us</h2>
			<ContactUsSection onOpenContact={onOpenContact} />

		</div>
	)
}
